import { render } from "./ui-text-editor.vue?vue&type=template&id=1d5e6aae&ts=true"
import script from "./ui-text-editor.vue?vue&type=script&lang=ts"
export * from "./ui-text-editor.vue?vue&type=script&lang=ts"

import "./ui-text-editor.vue?vue&type=style&index=0&id=1d5e6aae&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__